module.exports = __webpack_public_path__ + "img/team-3.08ced048.jpg";